import axios from "axios";
import { apiDomain } from "../../store/constants";

const TechnologyEvaluation = {
  index(payload) {
    return axios({
      url: apiDomain + "api/technology-evaluation/index",
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  create(payload) {
    return axios({
      url: apiDomain + "api/technology-evaluation/create",
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  save(payload) {
    return axios({
      url: apiDomain + "api/technology-evaluation/store",
      method: "POST",
      data: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  show(payload) {
    return axios({
      url: apiDomain + "api/technology-evaluation/" + payload.id +'/show',
      method: "GET",
      params: {
        page: payload.page,
        keyword: payload.keyword,
      },
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  edit(payload) {
    return axios({
      url: apiDomain + "api/technology-evaluation/" + payload.id +'/edit',
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  update(payload) {
    return axios({
      url: apiDomain + "api/technology-evaluation/" + payload.id +'/update',
      method: "PUT",
      data: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  delete(id) {
    return axios({
      url: apiDomain + "api/technology-evaluation/" + id +'/destroy',
      method: "DELETE",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  }
};

export default TechnologyEvaluation;